export default __webpack_public_path__ + "media/images/logo_transparent_black-06693e3c4efed59096243b4c3912977b.svg";